import { IslandContent } from "../../components/boundary/island/content";


export default function Island () {

  return (

    <>
        <IslandContent/>
    </>

  )

}